import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LegalEntityProfilePage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!user) {
        return null;
    }

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow">
            <div className="flex flex-col items-center mb-6">
                <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center text-3xl font-bold text-blue-600 mb-4">
                    {user.companyName?.[0]?.toUpperCase() || "L"}
                </div>

                <h2 className="text-2xl font-bold text-center">
                    {user.companyName || "Legal Entity Profile"}
                </h2>

                <p className="text-gray-500 text-sm">{user.email}</p>

                <p className="text-gray-600 mt-2">
                    <span className="font-bold">Role:</span>{" "}
                    {user.role || "Legal Entity"}
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <Info label="Company name" value={user.companyName} />
                <Info label="Tax ID" value={user.taxId} />
                <Info label="Registration number" value={user.registrationNumber} />
                <Info label="Contact person" value={user.contactPerson} />
                <Info label="Contact position" value={user.contactPosition} />
                <Info label="Company phone" value={user.companyPhone || user.phoneNumber} />
                <Info label="Country" value={user.manualCountry} />
                <Info label="City" value={user.manualCity} />
                <Info label="Postal code" value={user.manualPostalCode} />
                <Info label="Address" value={user.manualAddress} />
            </div>

            <div className="mt-6 p-4 bg-gray-50 rounded border">
                <p>
                    <span className="font-bold">2FA:</span>{" "}
                    {user.isTwoFactorEnabled ? (
                        <span className="text-green-600 font-medium">Enabled</span>
                    ) : (
                        <span className="text-red-600 font-medium">Disabled</span>
                    )}
                </p>
            </div>

            <div className="flex gap-3 mt-6">
                <button
                    onClick={() => navigate("/legal-entity")}
                    className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                >
                    Edit Company Data
                </button>

                {!user.isTwoFactorEnabled && (
                    <button
                        onClick={() => navigate("/enable-2fa")}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Enable 2FA
                    </button>
                )}
            </div>
        </div>
    );
};

function Info({ label, value }) {
    return (
        <div className="border rounded p-3 bg-gray-50">
            <div className="text-gray-500">{label}</div>
            <div className="font-medium">{value || "-"}</div>
        </div>
    );
}

export default LegalEntityProfilePage;